import { useEffect } from 'react';
import PropTypes from 'prop-types';

const KeyPressInterceptor = ({
    onKeyPressed = (f) => f,
    keyCodes = [],
}) => {

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => document.removeEventListener('keydown', handleKeyDown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleKeyDown = (event) => {
        let keyCodesArray = Array.isArray(keyCodes) ? keyCodes : [keyCodes];

        if (keyCodesArray.includes(event.keyCode)) {
            onKeyPressed();
        }
    }
}

KeyPressInterceptor.propTypes = {
    onKeyPressed: PropTypes.func.isRequired,
    keyCode: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.number.isRequired]),
};

export default KeyPressInterceptor;